import {
  CANCEL_ORDER_PREFERENCES_CHANGES,
  CLOSE_ORDER_PREFERENCES_ALERT,
  SAVE_ORDER_PREFERENCES,
  UPDATE_ORDER_PREFERENCES_INPUT_FIELD_VALUE,
  LOAD_ORDER_PREFERENCE_PAGE,
  INIT_COVER_PAGE_FIELDS,
} from 'constants/ActionTypes';

export const loadOrderPreferencePage = () => ({ type: LOAD_ORDER_PREFERENCE_PAGE });

export const updateInputFieldValue = (propertyName, key, value) => ({
  type: UPDATE_ORDER_PREFERENCES_INPUT_FIELD_VALUE, propertyName, key, value,
});

export const saveOrderPreferences = () => ({ type: SAVE_ORDER_PREFERENCES });

export const closeOrderPreferencesAlert = () => ({ type: CLOSE_ORDER_PREFERENCES_ALERT });

export const cancelOrderPreferencesChanges = () => ({ type: CANCEL_ORDER_PREFERENCES_CHANGES });

export const initializeCoverPageInputFields = (preferences) => ({ type: INIT_COVER_PAGE_FIELDS, preferences });
